// extracted by mini-css-extract-plugin
module.exports = {"divBackground":"Gradient_divBackground__2Vvvb"};